import {Box, Button, Dialog, DialogContent, Typography} from "@mui/material";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import {useKioskLang} from "../context/KioskSessionContext";

export default function IdleWarningDialog({open, remaining, onContinue, onCancel}) {
  const {tr} = useKioskLang();
  return (
    <Dialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogContent sx={{p: 4, textAlign: "center"}}>
        <Box sx={{width: 76, height: 76, mx: "auto", borderRadius: "50%", bgcolor: "#F7E6E3", color: "primary.main", display: "grid", placeItems: "center"}}>
          <AccessTimeRoundedIcon sx={{fontSize: 42}}/>
        </Box>
        <Typography sx={{fontSize: 32, fontWeight: 900, mt: 2}}>{tr("idleTitle")}</Typography>
        <Typography color="text.secondary" sx={{fontSize: 20, mt: 1}}>
          {tr("idleText", {n: remaining})}
        </Typography>
        <Box sx={{display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 2, mt: 4}}>
          <Button variant="outlined" onClick={onCancel}>{tr("idleCancel")}</Button>
          <Button variant="contained" onClick={onContinue}>{tr("keepOrdering")}</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
